import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Form, FormLayout, Page, TextField, Text, } from '@shopify/polaris';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { useRef, useCallback, useState } from 'react';
import LoginWithGoogleButton from '../components/LoginWithGoogleButton.tsx';
import { useGetLoginCodeRequest } from '../hooks/useGetLoginCodeRequest.ts';
import { useLoginRequest } from '../hooks/useLoginRequest.ts';
const LoginPage = ({ is_signup = false }) => {
    const [error, setError] = useState('');
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [isEnterCodeStage, setIsEnterCodeStage] = useState(false);
    const captchaRef = useRef(null);
    const [hToken, setHToken] = useState(null);
    const getLoginCodeRequest = useGetLoginCodeRequest();
    const loginRequest = useLoginRequest();
    const handleSubmit = useCallback(() => {
        if (!email || !email.includes('@') || !email.includes('.')) {
            setError('Invalid email');
            return;
        }
        else if (isEnterCodeStage && code.length !== 6) {
            setError('Code must be 6 digit length');
            return;
        }
        if (!isEnterCodeStage) {
            if (!hToken) {
                setError('Please complete the captcha');
                return;
            }
            getLoginCodeRequest(email, hToken)
                .then(function () {
                setIsEnterCodeStage(true);
                setError('');
            })
                .catch((e) => {
                setIsEnterCodeStage(false);
                setError((e && e.message) || e || 'Internal error');
            });
        }
        else {
            setError('');
            loginRequest(email, code)
                .then((answer) => {
                if (answer.message === 'ok') {
                    window.location.href = '/';
                }
                else {
                    setError('Unknown error');
                }
            })
                .catch((e) => {
                setTimeout(() => {
                    setError((e && e.message) || e || 'Internal error');
                }, 1000);
            });
        }
    }, [
        email,
        code,
        hToken,
        isEnterCodeStage,
        getLoginCodeRequest,
        loginRequest,
    ]);
    const handleEmailChange = useCallback((value) => {
        setEmail(value);
        setIsEnterCodeStage(false);
    }, []);
    const handleCodeChange = useCallback((value) => setCode(value), []);
    return (_jsx("div", { style: {
            height: '100%',
            width: '300px',
            margin: 'auto',
            display: 'flex',
            verticalAlign: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
        }, children: _jsx(Page, { title: is_signup ? 'Sign Up' : 'Sign In', children: _jsx(Form, { onSubmit: handleSubmit, children: _jsxs(FormLayout, { children: [_jsx(TextField, { value: email, onChange: handleEmailChange, label: "Email", type: "email", autoComplete: "email", helpText: !isEnterCodeStage &&
                                (is_signup ? (_jsxs("span", { children: ["Already have an account?", ' ', _jsx("a", { style: { textDecoration: 'none' }, href: '/login.html', children: "Sign In" }), _jsx("br", {}), _jsx("br", {}), _jsx("a", { target: '_blank', href: 'https://previewbuilder.com/privacypolicy.html', children: "Privacy policy" }), "\u00A0\u00A0\u00A0", _jsx("a", { target: '_blank', href: 'https://previewbuilder.com/tos.html', children: "Terms of service" })] })) : (_jsxs("span", { children: ["Don't have an account?", ' ', _jsx("a", { style: { textDecoration: 'none' }, href: '/signup.html', children: "Sign Up" }), _jsx("br", {}), _jsx("br", {}), _jsx("a", { target: '_blank', href: 'https://previewbuilder.com/privacypolicy.html', children: "Privacy policy" }), "\u00A0\u00A0\u00A0", _jsx("a", { target: '_blank', href: 'https://previewbuilder.com/tos.html', children: "Terms of service" })] }))) }), !isEnterCodeStage && (_jsx(HCaptcha, { ref: captchaRef, sitekey: '7862e3d8-99dc-4fba-91f0-ada2ba4ed6ac', onVerify: setHToken, onExpire: () => setHToken(null), onError: () => setHToken(null) })), isEnterCodeStage && (_jsx(TextField, { value: code, onChange: handleCodeChange, label: "Code", type: "text", autoComplete: "off", autoFocus: true, helpText: _jsx("span", { children: "Login code was sent to your email" }) })), error && (_jsx(Text, { as: 'span', variant: 'headingMd', tone: 'critical', children: error })), _jsx(Button, { variant: 'primary', submit: true, fullWidth: true, children: is_signup ? 'Sign Up' : 'Sign In' }), _jsx(LoginWithGoogleButton, { is_signup: is_signup })] }) }) }) }));
};
export default LoginPage;
